export const groupSelectAllValue = {
  facility_id: null,
  facility_name: null,
  id: 'all',
  name: 'All Groups',
  level_name: 'group',
  treeKey: 'all',
};
